export type JobKind = "composer_chat_turn" | "brief_plan" | "brief_draft";
export type ProviderAxis = "lovable" | "openrouter";
export type ModelOverrides = Partial<Record<JobKind, Partial<Record<ProviderAxis, string | null>>>>;

export type RoutingConfig = {
  openrouter_admin_enabled: boolean;
  cap_starter_monthly_usd: number;
  cap_plus_monthly_usd: number;
  cap_pro_monthly_usd: number;
  monthly_admin_budget_total_usd: number;
  disable_premium_writing_for_plus: boolean;
  disable_premium_writing_for_pro: boolean;
  model_overrides: ModelOverrides | null;
  updated_at: string | null;
  updated_by_user_id: string | null;
};

// The three admin-configurable AI paths. Each has an independent default
// model on the Lovable AI axis and the OpenRouter axis, and each is
// BYOK-eligible in the workspace settings card.
export const JOB_ROWS: Array<{ key: JobKind; label: string; description: string; lovableFallback: string; openrouterFallback: string }> = [
  { key: "composer_chat_turn", label: "AI Chat",        description: "Composer side-panel chat.",                  lovableFallback: "google/gemini-3-flash-preview", openrouterFallback: "anthropic/claude-3.5-haiku" },
  { key: "brief_plan",         label: "Planning Agent", description: "Intake → reviewable Brief.",                 lovableFallback: "google/gemini-2.5-flash-lite", openrouterFallback: "anthropic/claude-3.5-haiku" },
  { key: "brief_draft",        label: "Writing Agent",  description: "Approved Brief → Draft (and any refine).",   lovableFallback: "google/gemini-2.5-flash",      openrouterFallback: "anthropic/claude-3.5-sonnet" },
];
